import { ConfigurationError } from "./errors-CEDWDXew.js";
import { USER_AGENT } from "./version-Dl3bNTAd.js";
import { createOpenAI } from "@ai-sdk/openai";

//#region src/internal/agents/openrouter-provider.ts
const DEFAULT_OPENROUTER_MODEL = "openai/gpt-5.6-luna";
const DEFAULT_OPENROUTER_REASONING_EFFORT = "high";
const OPENROUTER_BASE_URL = "https://openrouter.ai/api/v1";
const OPENROUTER_REASONING_EFFORTS = [
	"none",
	"minimal",
	"low",
	"medium",
	"high",
	"xhigh"
];
const OPENROUTER_REASONING_EFFORT_ALIASES = Object.assign(Object.create(null), { max: "xhigh" });
function resolveOpenRouterReasoningEffort(value) {
	if (value === void 0) return DEFAULT_OPENROUTER_REASONING_EFFORT;
	if (value === "") return void 0;
	const normalized = value.trim().toLowerCase();
	if (Object.hasOwn(OPENROUTER_REASONING_EFFORT_ALIASES, normalized)) return OPENROUTER_REASONING_EFFORT_ALIASES[normalized];
	if (OPENROUTER_REASONING_EFFORTS.includes(normalized)) return normalized;
	throw new ConfigurationError(`Invalid OPENROUTER_REASONING_EFFORT "${value}". Expected one of: ${OPENROUTER_REASONING_EFFORTS.join(", ")}, max (alias for xhigh), or "" to omit.`);
}
/**
* Builds an OpenRouter chat-completions model for embedded agent calls.
*/
function getOpenRouterModel(model) {
	const factory = createOpenAI({
		apiKey: process.env.OPENROUTER_API_KEY,
		baseURL: OPENROUTER_BASE_URL,
		headers: {
			"User-Agent": USER_AGENT,
			"HTTP-Referer": "https://github.com/getsentry/sentry-mcp",
			"X-OpenRouter-Title": "Sentry MCP"
		}
	});
	return factory.chat(model ?? process.env.OPENROUTER_MODEL ?? DEFAULT_OPENROUTER_MODEL);
}
/**
* Provider options for OpenRouter chat-completions calls.
*
* Uses the OpenAI chat provider options shape because OpenRouter is accessed
* through `@ai-sdk/openai` with an OpenRouter base URL.
*/
function getOpenRouterProviderOptions() {
	const reasoningEffort = resolveOpenRouterReasoningEffort(process.env.OPENROUTER_REASONING_EFFORT);
	return { openai: {
		structuredOutputs: false,
		strictJsonSchema: false,
		...reasoningEffort ? { reasoningEffort } : {}
	} };
}

//#endregion
export { getOpenRouterModel, getOpenRouterProviderOptions };
//# sourceMappingURL=openrouter-provider-JT8w8qQ6.js.map